@if (isOpen()) {
  <div class="modal-overlay" (click)="onOverlayClick($event)">
    <div
      class="modal-container glass-panel animate-scale-up"
      [style.max-width]="maxWidth()"
      (click)="$event.stopPropagation()">

      <!-- Modal Header -->
      <div class="modal-header">
        <div class="modal-title-area">
          <div class="modal-title-with-icon">
            @if (iconType() !== 'none') {
              <div class="modal-header-icon" [ngClass]="'icon-' + iconType()">
                <ng-content select="[modal-header-icon]">
                  <!-- Default icon if none provided -->
                  <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="16" x2="12" y2="12"></line>
                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                  </svg>
                </ng-content>
              </div>
            } @else {
              <ng-content select="[modal-header-icon]"></ng-content>
            }

            <div class="modal-title-text">
              @if (title()) {
                <h3>{{ title() }}</h3>
              }
              <ng-content select="[modal-header-title]"></ng-content>

              @if (description()) {
                <p class="modal-desc">{{ description() }}</p>
              }
              <ng-content select="[modal-header-desc]"></ng-content>
            </div>
          </div>
        </div>

        <div class="modal-header-extra">
          <ng-content select="[modal-header-extra]"></ng-content>
        </div>

        @if (showCloseButton()) {
          <button type="button" class="btn-close-modal" (click)="close.emit()" title="닫기">
            <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        }
      </div>

      <!-- Modal Body (Scrollable Content Slot) -->
      <div class="modal-body">
        <ng-content></ng-content>
      </div>

      <!-- Optional Modal Footer Slot -->
      <div class="modal-footer">
        <ng-content select="[modal-footer]"></ng-content>
      </div>
    </div>
  </div>
}
